module.exports = __webpack_public_path__ + "img/icon_api@2x(1).95fc170c.png";